const resources = {
  spins: { name: "Крутки", image: "assets/resource-emojis/card.webp" },
  crystals: { name: "Кристаллы", image: "assets/resource-emojis/crystal.webp" },
  currency: { name: "Тыквы", image: "assets/home-halloween/pumpkin-v2.webp" },
};

export function chestRevealResult(items) {
  const ordered = [...items.filter(item => item.type !== "card"), ...items.filter(item => item.type === "card")];
  return { kind: "event-chest", cards: ordered.map(item => {
    if (item.type === "card") return { ...item, name: `${item.name} #${item.number}`, points: item.points || 0 };
    const resource = resources[item.type];
    return { name: resource.name, rewardType: item.type, amount: item.amount,
      rarity: "Ресурс", points: 0, mediaPath: resource.image, thumbnailPath: resource.image };
  }) };
}
